// Which kind of gate a failed request deserves. Kept out of AdminGate.tsx so that
// file only exports a component (fast-refresh).

import { isAxiosError } from 'axios'

export function httpStatusOf(error: unknown): number | undefined {
  return isAxiosError(error) ? error.response?.status : undefined
}

export type GateKind = 'permission' | 'forbidden' | 'not-set-up' | 'failed'

export function gateKindFor(error: unknown): GateKind {
  const status = httpStatusOf(error)
  if (status === 403) return 'forbidden'
  if (status === 404) return 'not-set-up'
  return 'failed'
}
